import React from 'react';
import {
  Box,
  Button,
  Divider,
  Drawer,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { alpha } from '@mui/material/styles';

interface ContactDrawerProps {
  open: boolean;
  onClose: () => void;
}

export const ContactDrawer: React.FC<ContactDrawerProps> = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Drawer anchor={isMobile ? 'bottom' : 'top'} open={open} onClose={onClose} ModalProps={{ keepMounted: true }}>
      <Box
        sx={{
          px: { xs: 3, sm: 6 },
          py: { xs: 3, sm: 4 },
          backgroundColor: theme.palette.background.paper,
          borderTopLeftRadius: isMobile ? 24 : 0,
          borderTopRightRadius: isMobile ? 24 : 0,
          borderBottomLeftRadius: isMobile ? 0 : 24,
          borderBottomRightRadius: isMobile ? 0 : 24,
          boxShadow: `0 24px 58px ${alpha(theme.palette.primary.main, 0.18)}`,
        }}
      >
        <Stack spacing={3}>
          <Box>
            <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 600 }}>
              Let's collaborate
            </Typography>
            <Typography variant="h5" sx={{ mt: 1 }}>
              Built by Nikita Baklazhenko
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1.5 }}>
              Data Scientist & ML Engineer. Feel free to reach out if you have any questions, concerns, found bugs, or want to collaborate on any projects.
            </Typography>
          </Box>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Button
              variant="outlined"
              color="primary"
              href="https://www.linkedin.com/in/nikita-baklazhenko/"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </Button>
            <Button variant="outlined" href="mailto:nikita.baklazhenko@bse.eu" color="secondary">
              Email
            </Button>
          </Stack>

          <Divider />
        </Stack>
      </Box>
    </Drawer>
  );
};
